import React from 'react'

// DIP ICONS
const BlueCheeseIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M3 6 L21 6 Q22 6 22 7 L22 18 Q22 19 21 19 L3 19 Q2 19 2 18 L2 7 Q2 6 3 6 Z"
      fill="#FFD700"
      stroke="#E6C200"
      strokeWidth="0.8"
    />
    <circle cx="6" cy="10" r="1.5" fill="#0066CC" opacity="0.9" />
    <circle cx="12" cy="13" r="1.2" fill="#0066CC" opacity="0.9" />
    <circle cx="18" cy="11" r="1.8" fill="#0066CC" opacity="0.9" />
    <circle cx="8" cy="16" r="1" fill="#0066CC" opacity="0.9" />
    <circle cx="16" cy="15" r="1.3" fill="#0066CC" opacity="0.9" />
    <path d="M2 6 Q12 4 22 6" fill="none" stroke="#E6C200" strokeWidth="0.8" />
  </svg>
)

const RanchIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="6"
      y="3"
      width="12"
      height="18"
      rx="3"
      fill="#FFFFFF"
      stroke="#CCCCCC"
      strokeWidth="0.8"
    />
    <rect x="8" y="1" width="8" height="4" rx="2" fill="#E0E0E0" />
    <circle cx="9" cy="7" r="0.6" fill="#90EE90" />
    <circle cx="15" cy="9" r="0.5" fill="#90EE90" />
    <circle cx="12" cy="11" r="0.7" fill="#90EE90" />
    <circle cx="10" cy="14" r="0.5" fill="#90EE90" />
    <circle cx="14" cy="16" r="0.6" fill="#90EE90" />
    <circle cx="11" cy="18" r="0.4" fill="#90EE90" />
    <rect x="9" y="2" width="6" height="1.5" fill="#BDBDBD" />
  </svg>
)

const GarlicSauceIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="6"
      y="4"
      width="12"
      height="17"
      rx="3"
      fill="#FFFDE7"
      stroke="#CCCCCC"
      strokeWidth="0.8"
    />
    <rect x="8" y="2" width="8" height="4" rx="2" fill="#E0E0E0" />
    <circle
      cx="12"
      cy="12"
      r="3.5"
      fill="#FFFFFF"
      stroke="#E6E6E6"
      strokeWidth="0.5"
    />
    <path d="M9 12 Q12 9 15 12 Q12 15 9 12" fill="#F5F5DC" />
    <circle cx="10" cy="8" r="0.4" fill="#E6E6E6" />
    <circle cx="14" cy="17" r="0.4" fill="#E6E6E6" />
    <rect x="9" y="2.5" width="6" height="1" fill="#BDBDBD" />
  </svg>
)

const HoneyMustardIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="6"
      y="4"
      width="12"
      height="17"
      rx="3"
      fill="#FFD700"
      stroke="#DAA520"
      strokeWidth="0.8"
    />
    <rect x="8" y="2" width="8" height="4" rx="2" fill="#E0E0E0" />
    <circle cx="12" cy="12" r="3" fill="#FFA500" opacity="0.6" />
    <path d="M9 10 Q12 8 15 10 Q15 14 12 16 Q9 14 9 10" fill="#FFB347" />
    <circle cx="10" cy="8" r="0.5" fill="#DAA520" />
    <circle cx="14" cy="17" r="0.5" fill="#DAA520" />
    <circle cx="11" cy="14" r="0.4" fill="#DAA520" />
    <rect x="9" y="2.5" width="6" height="1" fill="#BDBDBD" />
  </svg>
)

// SAUCE ICONS
const LemonPepperIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <ellipse
      cx="12"
      cy="12"
      rx="8"
      ry="10"
      fill="#FFD700"
      stroke="#E6C200"
      strokeWidth="0.8"
    />
    <path d="M12 2 Q15 5 12 8 Q9 5 12 2" fill="#4CAF50" />
    <circle cx="9" cy="9" r="0.6" fill="#333333" />
    <circle cx="15" cy="13" r="0.6" fill="#333333" />
    <circle cx="10" cy="16" r="0.5" fill="#333333" />
    <circle cx="14" cy="10" r="0.5" fill="#333333" />
    <circle cx="12" cy="14" r="0.7" fill="#333333" />
    <circle cx="11" cy="11" r="0.4" fill="#333333" />
    <circle cx="13" cy="16" r="0.4" fill="#333333" />
    <path
      d="M6 12 Q12 10 18 12"
      stroke="#E6C200"
      strokeWidth="0.8"
      fill="none"
    />
  </svg>
)

const LouisianaRubIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="5"
      y="3"
      width="14"
      height="18"
      rx="3"
      fill="#8B4513"
      stroke="#654321"
      strokeWidth="0.8"
    />
    <rect x="7" y="1" width="10" height="4" rx="2" fill="#A0522D" />
    <circle cx="8" cy="7" r="0.8" fill="#FF4444" />
    <circle cx="13" cy="9" r="0.6" fill="#FFD700" />
    <circle cx="16" cy="7" r="0.8" fill="#4CAF50" />
    <circle cx="9" cy="12" r="0.6" fill="#FF4444" />
    <circle cx="15" cy="14" r="0.8" fill="#8B4513" />
    <circle cx="11" cy="16" r="0.6" fill="#FFD700" />
    <circle cx="14" cy="18" r="0.5" fill="#4CAF50" />
    <circle cx="10" cy="19" r="0.5" fill="#FF6600" />
    <rect x="8" y="2" width="8" height="1.5" fill="#FFFFFF" opacity="0.4" />
  </svg>
)

const MildSauceIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="6"
      y="4"
      width="12"
      height="17"
      rx="3"
      fill="#DC143C"
      stroke="#B71C1C"
      strokeWidth="0.8"
    />
    <rect x="8" y="2" width="8" height="4" rx="2" fill="#E0E0E0" />
    <path d="M9 8 Q12 5 15 8 Q15 14 12 17 Q9 14 9 8" fill="#FF6666" />
    <circle cx="10" cy="18" r="0.5" fill="#FF4444" />
    <circle cx="14" cy="19" r="0.5" fill="#FF4444" />
    <circle cx="12" cy="19.5" r="0.4" fill="#FF4444" />
    <rect x="9" y="2.5" width="6" height="1" fill="#BDBDBD" />
  </svg>
)

const HotHoneyIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M6 5 L18 5 Q19 5 19 6 L19 18 Q19 20 17 20 L7 20 Q5 20 5 18 L5 6 Q5 5 6 5 Z"
      fill="#FFB347"
      stroke="#E6A000"
      strokeWidth="0.8"
    />
    <path d="M6 5 Q12 2 18 5" fill="none" stroke="#E6A000" strokeWidth="0.8" />
    <polygon points="9,9 12,6 15,9 14,13 10,13" fill="#FF4444" />
    <circle cx="12" cy="16" r="2" fill="#E6A000" opacity="0.4" />
    <path
      d="M7 7 L17 7 M7 18 L17 18"
      stroke="#E6A000"
      strokeWidth="0.6"
      opacity="0.7"
    />
    <path d="M8 15 L16 15" stroke="#E6A000" strokeWidth="0.4" opacity="0.5" />
  </svg>
)

// SIDES ICONS
const CornTraysIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="2"
      y="7"
      width="20"
      height="12"
      rx="3"
      fill="#D2691E"
      stroke="#A0522D"
      strokeWidth="0.8"
    />
    <rect x="1" y="6" width="22" height="3" rx="2" fill="#F4A460" />
    <rect x="4" y="10" width="4" height="8" rx="2" fill="#FFD54F" />
    <rect x="10" y="10" width="4" height="8" rx="2" fill="#FFD54F" />
    <rect x="16" y="10" width="4" height="8" rx="2" fill="#FFD54F" />
    <circle cx="6" cy="11" r="0.3" fill="#FF8F00" />
    <circle cx="12" cy="12" r="0.3" fill="#FF8F00" />
    <circle cx="18" cy="11" r="0.3" fill="#FF8F00" />
    <circle cx="6" cy="13" r="0.3" fill="#FF8F00" />
    <circle cx="12" cy="14" r="0.3" fill="#FF8F00" />
    <circle cx="18" cy="13" r="0.3" fill="#FF8F00" />
  </svg>
)

// DESSERT ICONS
const BrowniesIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="4"
      y="6"
      width="16"
      height="14"
      rx="2"
      fill="#3E2723"
      stroke="#2E1A17"
      strokeWidth="0.8"
    />
    <rect x="6" y="8" width="5" height="5" fill="#5D4037" />
    <rect x="13" y="8" width="5" height="5" fill="#5D4037" />
    <rect x="6" y="14" width="5" height="4" fill="#5D4037" />
    <rect x="13" y="14" width="5" height="4" fill="#5D4037" />
    <circle cx="8" cy="10" r="0.8" fill="#8D6E63" opacity="0.7" />
    <circle cx="15" cy="11" r="0.6" fill="#8D6E63" opacity="0.7" />
    <circle cx="9" cy="16" r="0.7" fill="#8D6E63" opacity="0.7" />
    <circle cx="16" cy="15" r="0.5" fill="#8D6E63" opacity="0.7" />
    <circle cx="7" cy="12" r="0.4" fill="#6D4C41" />
    <circle cx="14" cy="9" r="0.4" fill="#6D4C41" />
    <circle cx="17" cy="17" r="0.4" fill="#6D4C41" />
    <path
      d="M4 6 Q12 4 20 6"
      fill="none"
      stroke="#2E1A17"
      strokeWidth="0.6"
      opacity="0.5"
    />
  </svg>
)

// VEGETABLE ICONS
const CarrotsIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M8 5 C9.5 5 10.5 6 10.5 7 L10.5 20 C10.5 21 9.5 22 8 22 C6.5 22 5.5 21 5.5 20 L5.5 7 C5.5 6 6.5 5 8 5 Z"
      fill="#FF6B35"
      stroke="#E55A2B"
      strokeWidth="0.5"
    />
    <path
      d="M16 6 C17.5 6 18.5 7 18.5 8 L18.5 21 C18.5 22 17.5 23 16 23 C14.5 23 13.5 22 13.5 21 L13.5 8 C13.5 7 14.5 6 16 6 Z"
      fill="#FF5722"
      stroke="#D84315"
      strokeWidth="0.5"
    />
    <path d="M8 5 Q7 3 6 1 Q6.5 0.5 7 1 Q8 3 8 5" fill="#4CAF50" />
    <path d="M16 6 Q15 4 14 2 Q14.5 1.5 15 2 Q16 4 16 6" fill="#4CAF50" />
    <path d="M8 5 Q9 3 10 2 Q9.5 1.5 9 2 Q8 3.5 8 5" fill="#4CAF50" />
    <path d="M16 6 Q17 4 18 3 Q17.5 2.5 17 3 Q16 4.5 16 6" fill="#4CAF50" />
    <circle cx="7" cy="12" r="0.4" fill="#E55A2B" />
    <circle cx="15" cy="14" r="0.4" fill="#D84315" />
  </svg>
)

const CeleryIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect
      x="6"
      y="8"
      width="2.5"
      height="14"
      fill="#90EE90"
      stroke="#66BB66"
      strokeWidth="0.3"
    />
    <rect
      x="9.5"
      y="6"
      width="2.5"
      height="16"
      fill="#90EE90"
      stroke="#66BB66"
      strokeWidth="0.3"
    />
    <rect
      x="13"
      y="7"
      width="2.5"
      height="15"
      fill="#90EE90"
      stroke="#66BB66"
      strokeWidth="0.3"
    />
    <rect
      x="16.5"
      y="8"
      width="2.5"
      height="14"
      fill="#90EE90"
      stroke="#66BB66"
      strokeWidth="0.3"
    />
    <path d="M6 8 Q5 6 4 3 Q4.5 2.5 5 3 Q6 6 6 8" fill="#228B22" />
    <path d="M9.5 6 Q8.5 4 7.5 1 Q8 0.5 8.5 1 Q9.5 4 9.5 6" fill="#228B22" />
    <path d="M13 7 Q12 5 11 2 Q11.5 1.5 12 2 Q13 5 13 7" fill="#228B22" />
    <path
      d="M16.5 8 Q15.5 6 14.5 3 Q15 2.5 15.5 3 Q16.5 6 16.5 8"
      fill="#228B22"
    />
    <path d="M19 8 Q18 6 17 3 Q17.5 2.5 18 3 Q19 6 19 8" fill="#228B22" />
    <rect x="7" y="12" width="1" height="8" fill="#FFFFFF" opacity="0.4" />
    <rect x="10.5" y="10" width="1" height="10" fill="#FFFFFF" opacity="0.4" />
    <rect x="14" y="11" width="1" height="9" fill="#FFFFFF" opacity="0.4" />
  </svg>
)

// Main getIcon function without category colors
export const getIcon = (itemId: string, size: number = 28) => {
  // DIPS
  if (itemId.includes('blue-cheese')) return <BlueCheeseIcon size={size} />
  if (itemId.includes('ranch')) return <RanchIcon size={size} />
  if (itemId.includes('garlic-sauce')) return <GarlicSauceIcon size={size} />
  if (itemId.includes('honey-mustard')) return <HoneyMustardIcon size={size} />

  // SAUCES
  if (itemId.includes('lemon-pepper')) return <LemonPepperIcon size={size} />
  if (itemId.includes('louisiana-rub')) return <LouisianaRubIcon size={size} />
  if (itemId.includes('mild-sauce')) return <MildSauceIcon size={size} />
  if (itemId.includes('hot-honey')) return <HotHoneyIcon size={size} />

  // SIDES
  if (itemId.includes('corn-trays')) return <CornTraysIcon size={size} />

  // VEGETABLES
  if (itemId.includes('carrots')) return <CarrotsIcon size={size} />
  if (itemId.includes('celery')) return <CeleryIcon size={size} />

  // BROWNIES
  if (itemId.includes('brownies')) return <BrowniesIcon size={size} />

  // Default fallback
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="3"
        fill="#9E9E9E"
        stroke="#757575"
        strokeWidth="0.8"
      />
      <text
        x="12"
        y="13"
        textAnchor="middle"
        fontSize="10"
        fill="#FFFFFF"
        fontWeight="bold"
      >
        ?
      </text>
    </svg>
  )
}

// Usage examples:
// getIcon('Blue Cheese')              // Large blue cheese icon
// getIcon('Ranch', 24)                // Large ranch bottle at 24px
// getIcon('Carrots')                  // Large carrots with green tops
